<template lang="pug">
.bloco-bioma(:class='[isValue ? "cinza" : "verde"]')
    .bloco-bioma__titulo
        .bloco-bioma__titulo-interno
            span {{ titulo }}
        .bloco-bioma__titulo-icone
            el-checkbox(
                v-model='checked',
                label='',
                size='large',
                :disabled='isValue'
            )

    .bloco-bioma__interno
        .bloco-bioma__interno-alinhamento
            span.bloco-bioma__interno-valor {{ valor ? valor : '-' }}

        .bloco-bioma__interno-alinhamento
            span.bloco-bioma__interno-normal Área:
            span.bloco-bioma__interno-verde {{ valorArea ? valorArea + ' ha' : '-' }}

        .bloco-bioma__interno-alinhamento
            span.bloco-bioma__interno-normal Imóveis:
            span.bloco-bioma__interno-verde {{ imoveis ? imoveis : '-' }}
</template>

<script>
export default {
    name: 'BlocoBiomas',
    props: {
        titulo: {
            type: String,
            default: () => ''
        },
        valor: {
            type: String,
            default: () => ''
        },
        valorArea: {
            type: String,
            default: () => ''
        },
        imoveis: {
            type: String,
            default: () => ''
        }
    },
    data() {
        return {
            checked: false
        };
    },
    computed: {
        isValue: function () {
            return !this.valor;
        }
    }
};
</script>

<style lang="scss" scoped>
.bloco-bioma {
    min-width: 16%;
    background: var(--white);
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    min-height: 89px;
    color: var(--primary);
    flex-wrap: wrap;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    padding: 12px 10px 20px;
    flex-direction: column;
    .bloco-bioma__titulo {
        display: flex;
        justify-content: space-between;
        align-self: normal;
    }
    .bloco-bioma__titulo-interno {
        width: 90%;
        font-size: 18px;
        font-weight: 700;
        display: flex;
    }
    .bloco-bioma__titulo-icone {
        width: 10%;
        font-size: 22px;
        display: flex;
        align-items: center;
    }
    .bloco-bioma__interno {
        margin-right: 3px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 90%;
        .bloco-bioma__interno-alinhamento {
            display: flex;
        }
    }
    .bloco-bioma__interno-dados {
        flex-wrap: wrap;
        font-size: 20px;
    }
    span {
        &.bloco-bioma__interno-valor {
            max-width: 184px;
            font-weight: 600;
            font-size: 18px;
            padding: 0px;
        }

        &.bloco-bioma__interno-normal {
            font-weight: 300;
        }
        &.bloco-bioma__interno-verde {
            font-weight: 300;
            margin-left: 3px;
        }
    }

    &:first-child {
        margin: 2px 3px 2px 0px;
    }

    &:not(:first-child) {
        margin: 2px 3px 2px 2px;
    }
}

.verde {
    border-left: solid var(--secondary-two) 10px;
    .bloco-bioma__titulo-interno {
        color: var(--secondary-two) !important;
    }
    .bloco-bioma__titulo-icone {
        color: var(--secondary-two);
    }
    .bloco-bioma__interno-verde {
        color: var(--secondary-two);
    }
}

.cinza {
    border-left: solid var(--background-disabled) 10px;
    .bloco-bioma__titulo-interno {
        color: var(--background-disabled) !important;
    }
    .bloco-bioma__titulo-icone {
        color: var(--background-disabled);
    }
    .bloco-bioma__interno-verde {
        color: var(--background-disabled);
    }
    .bloco-bioma__interno-normal {
        color: var(--background-disabled);
    }
    .bloco-bioma__interno-valor {
        color: var(--background-disabled);
    }
}
</style>
